import React from 'react'

import { StepState } from './useWizardState'

export const WizardContext = React.createContext<{
  state: StepState
  setStep: (step: any) => void
  setSubStep: (step: any) => void
  store: any
  setStore: React.Dispatch<any>
}>(null)
